import React from 'react';

import {PageFooter} from '@pb/kit-component-page-v2';

const copyrightSymbol = String.fromCharCode(0xA9);
const currentYear = new Date().getFullYear();

export const DefaultAppFooter = () => (
    <PageFooter copyright={`${copyrightSymbol} ${currentYear} PitchBook Data, Inc. All rights reserved.`}>
        <a href="https://pitchbook.com/terms-of-use" target="_blank">Terms of Use</a>
        <a href="https://pitchbook.com/privacy-policy" target="_blank">Privacy</a>
    </PageFooter>
);

